<template>
    <v-row class="light--text" v-show="selectedMenu === 3">
        <v-container ma-0 pa-0 px-4 class="">
            <v-row style="flex-wrap: nowrap">
                <v-col cols="10" md6 offset-md="2" class="pa-1 ma-0"
                >
                    <v-card class="blue-grey lighten-5 d-flex flex-column" >
                        <v-card-text class="pa-0 ma-0"
                                     v-for="(moderator, index) in moderators"
                                     :key="moderator.id"
                        >
                            <moderator-card
                                    :model="moderator"
                                    :index="index"
                                    @removeModel="removeModerator"
                            ></moderator-card>
                        </v-card-text>
                        <v-text-field
                            label="Добавить модератора по id"
                            required
                            hide-details
                            v-model="moderator_id"
                            class=""
                        ></v-text-field>
                        <v-btn color="blue lighten-2" dark @click="addModerator">Добавить</v-btn>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <v-snackbar
                v-model="snackbar"
                bottom
                :color="paramsSnackbar.color"
                right
        >
            {{paramsSnackbar.text}}
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
        <dialog-confirmation ref="confirm" :dialogParams="dialogParams"></dialog-confirmation>
    </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import DialogConfirmation from '../../dialogs/DialogConfirmation'
import ModeratorCard from './ModeratorCard'
export default {
    name: 'BotModerator',
    data() {
        return {
            moderator_id: null,
            dialogParams: {},
            paramsSnackbar: {
                color: 'success',
                text: 'Успешно сохранено!'
            },
            snackbar: false
        }
    },
    components: {
        ModeratorCard,
        DialogConfirmation
    },
    props: ['botModel', 'selectedMenu'],
    methods: {
        loadModerators() {
            this.$store.dispatch('bots/loadModerators', this.botModel.id)
        },
        addModerator() {
            let moderatorExists = this.getModeratorById(this.moderator_id)
            if (moderatorExists !== -1) {
                this.paramsSnackbar.color = 'success'
                this.paramsSnackbar.text = 'Модератор добавлен!'
                this.snackbar = true
                return 'ok'
            } else {
                let model = {
                    bot_id: this.botModel.id,
                    moderator_id: this.moderator_id
                }

                this.$store.dispatch('bots/createModerator', model).then(response => {
                    if (response !== undefined && response.data.hasOwnProperty('success')) {
                        this.paramsSnackbar.color = 'success'
                        this.paramsSnackbar.text = 'Модератор добавлен!'
                    } else {
                        this.paramsSnackbar.color = 'error'
                        this.paramsSnackbar.text = 'Ошибка при добавлении модеритора'
                    }
                    this.snackbar = true
                })
            }
        },
        async removeModerator(index) {
            this.$refs.confirm.open('Удаление сообщения', 'Вы действительно хотите удалить?',
                { color: 'red', agree: 'Подтверждаю', cancel: 'Отмена' })
                .then((confirm) => {
                    if (confirm === true) {
                        this.$store.dispatch('bots/removeModerator', index)
                    }
                })
        }
    },
    computed: {
        ...mapGetters({
            moderators: 'bots/moderators',
            modelModeratorDef: 'bots/modelModeratorDef',
            getModeratorById: 'bots/getModeratorById'
        })
    },
    watch: {
        selectedMenu(value) {
            if (value === 3) { this.loadModerators() }
        }
    }
}
</script>

<style scoped lang="scss">
    ::-webkit-scrollbar {
        width: $width-scroll-panel;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $light;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $blue-active ;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $blue-inactive;
    }
    .container {
        height: 60vh;
        display: flex;
        flex-direction: column;
    }
    .container-with-cards {
        height: calc(100vh - 150px);
    }
</style>
